import { createClient } from "@connectrpc/connect";

import { AccountingService } from "@/gen/omnios/v1/accounting_connect";
import { transport } from "@/lib/grpc";

export const accountingClient = createClient(AccountingService, transport);
